var _rect, _g, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
var SvgBtnMergeCard = function SvgBtnMergeCard(props) {
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#".concat(_id, ")")
  }, /*#__PURE__*/React.createElement("mask", {
    id: "btn-merge-card_svg__mask0_259_6318",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#btn-merge-card_svg__mask0_259_6318)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 2.4375C14.6391 2.4375 15.5625 3.36091 15.5625 4.5V13.5C15.5625 14.6391 14.6391 15.5625 13.5 15.5625H4.5C3.36091 15.5625 2.4375 14.6391 2.4375 13.5V4.5C2.4375 3.36091 3.36091 2.4375 4.5 2.4375H13.5ZM4.5 3.5625C3.98223 3.5625 3.5625 3.98223 3.5625 4.5V13.5C3.5625 14.0178 3.98223 14.4375 4.5 14.4375H13.5C14.0178 14.4375 14.4375 14.0178 14.4375 13.5V4.5C14.4375 3.98223 14.0178 3.5625 13.5 3.5625H4.5ZM8.35449 9.00781C8.66501 9.00793 8.91693 9.25978 8.91699 9.57031V11.4453C8.91699 11.7559 8.66505 12.0077 8.35449 12.0078C8.04383 12.0078 7.79199 11.756 7.79199 11.4453V10.9473L5.84473 12.8945C5.62505 13.1142 5.26849 13.1142 5.04883 12.8945C4.82925 12.6749 4.82921 12.3183 5.04883 12.0986L7.01562 10.1328H6.47949C6.16883 10.1328 5.91699 9.88097 5.91699 9.57031C5.91706 9.25971 6.16887 9.00781 6.47949 9.00781H8.35449ZM12.4736 4.67383C12.6933 4.45427 13.0499 4.45421 13.2695 4.67383C13.4892 4.89346 13.4891 5.25005 13.2695 5.46973L11.3223 7.41699H11.8203C12.1309 7.41703 12.3828 7.66885 12.3828 7.97949C12.3827 8.29002 12.1309 8.54196 11.8203 8.54199H9.94531C9.67356 8.54199 9.44707 8.34898 9.39453 8.09277L9.38281 7.97949V6.10449C9.38281 5.79383 9.63465 5.54199 9.94531 5.54199C10.2559 5.54203 10.5078 5.79385 10.5078 6.10449V6.63965L12.4736 4.67383Z",
    fill: "#39404D"
  })))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: _id
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
};
export default SvgBtnMergeCard;